<gnx-top-nav [activeMiniApp]="MiniApps.ClinicalDB" />
<div class="header-container">
  <gnx-breadcrumb [crumbs]="crumbs" />
  <div class="page-header">
    <strong>Scientific Publications</strong>
    <div class="citation-info">
      <span class="info-title">Citing Franklin</span>
      <strong>We highly appreciate your wish to cite us in your publication.</strong>
      We are in the process of completing publishing a peer-reviewed paper on Franklin and the methodology used. For
      now, please cite us using our website address:
      <strong>https://franklin.genoox.com - Franklin by Genoox</strong>
    </div>
  </div>
</div>
<div class="citations-container">
  @if (citationsResponse(); as response) {
    <div class="citations">
      @for (citation of response?.citations; track citation) {
        <a [href]="citation.link" target="_blank">
          <gnx-citations-tile [citation]="citation" />
        </a>
      }
    </div>
  }
</div>
